
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitokashicabservice() {



    const cardData =
    {
        keyword: ' Mumbai to Kashi Cab Service',
        heading: 'Vedant Travels: Mumbai to Kashi Cab Service',
        headingDescription: 'Vedant Travels offers a comfortable and reliable cab service from Mumbai to Kashi (Varanasi) for pilgrims and travelers. Whether you’re visiting the sacred Kashi Vishwanath Temple or exploring the spiritual ghats of the Ganges River, our well-maintained fleet of sedans, SUVs, and luxury cars ensures a hassle-free journey. With professional drivers, flexible pickup and drop-off options, 24/7 availability, and affordable fares, we make your long-distance travel smooth and convenient.',

        top: 'Top Places to Visit in Kashi with Vedant Travels',

"topPlaces": [
    {
        "title": "Kashi Vishwanath Temple",
        "description": "One of the 12 Jyotirlingas, this temple is dedicated to Lord Shiva and is a major pilgrimage site in India. Devotees from all over visit to seek blessings and witness the divine aarti."
    },
    {
        "title": "Dashashwamedh Ghat",
        "description": "The most vibrant and famous ghat in Varanasi, known for its Ganga Aarti held every evening. The mesmerizing ritual, with priests performing prayers to the river with lamps, is a must-watch."
    },
    {
        "title": "Manikarnika Ghat",
        "description": "A significant cremation ghat in Hindu culture, symbolizing the cycle of life and death. It is believed that those cremated here attain moksha (liberation)."
    },
    {
        "title": "Sarnath",
        "description": "Located just 10 km from Varanasi, Sarnath is where Lord Buddha gave his first sermon. Key attractions include the Dhamek Stupa, Mulagandha Kuti Vihar, and the Ashoka Pillar."
    },
    {
        "title": "Assi Ghat",
        "description": "A peaceful and scenic ghat where visitors can relax, meditate, and participate in the Subah-e-Banaras (morning aarti and yoga sessions)."
    },
    {
        "title": "Sankat Mochan Hanuman Temple",
        "description": "A famous temple dedicated to Lord Hanuman, known for its spiritual significance and the continuous chanting of Sundarkand."
    },
    {
        "title": "Bharat Mata Temple",
        "description": "Unlike traditional temples, this one is dedicated to Mother India, featuring a huge relief map of India carved in marble."
    },
    {
        "title": "Tulsi Manas Temple",
        "description": "This temple is built at the site where Tulsidas wrote the Ramcharitmanas. The temple walls are inscribed with verses from the epic."
    },
    {
        "title": "Ramnagar Fort",
        "description": "Situated on the eastern bank of the Ganges, this 18th-century fort showcases vintage cars, weapons, and royal artifacts."
    },
    {
        "title": "Banaras Hindu University (BHU)",
        "description": "One of the largest universities in Asia, home to the New Vishwanath Temple, a stunning architectural marvel open to visitors."
    }
],

"services": [
    {
        "name": "Mumbai to Kashi Cab Service by Vedant Travels",
        "description": "Traveling from Mumbai to Kashi? Vedant Travels offers reliable and comfortable cab services for your journey to the spiritual city of Kashi. Whether you’re visiting for religious purposes, a cultural tour, or any other reason, we ensure you have a smooth and safe ride."
    },
    {
        "name": "Mumbai to Kashi One Way Taxi",
        "description": "For a one-way journey from Mumbai to Kashi, choose Vedant Travels. We offer affordable and efficient one-way taxi services, ensuring you reach your destination comfortably and on time without the hassle of returning."
    },
    {
        "name": "Mumbai to Kashi Car Hire",
        "description": "Rent a car from Mumbai to Kashi with Vedant Travels for a flexible and personalized travel experience. Our fleet includes a range of vehicles to suit your needs, ensuring a comfortable and convenient trip to the sacred city of Kashi."
    },
    {
        "name": "Mumbai to Kashi Taxi Booking",
        "description": "Booking your taxi from Mumbai to Kashi is easy with Vedant Travels. You can book your ride online or by phone, ensuring a quick and hassle-free process. Let us handle your transportation needs while you focus on enjoying your trip."
    },
    {
        "name": "Kashi Darshan Taxi",
        "description": "For a peaceful and spiritual journey to Kashi, Vedant Travels offers special Kashi Darshan taxi services. Our experienced drivers will take you to all the important religious sites in Kashi, ensuring you have a fulfilling and memorable experience."
    },
    {
        "name": "Mumbai to Kashi Innova",
        "description": "Traveling with a group or looking for extra comfort? Book an Innova for your journey from Mumbai to Kashi. The Innova offers ample space and luxury, making it perfect for families or groups visiting the holy city of Kashi."
    },
    {
        "name": "Mumbai to Kashi Trip",
        "description": "Vedant Travels offers seamless trip services from Mumbai to Kashi. Our professional drivers, comfortable vehicles, and tailored travel plans ensure you have a relaxed and pleasant experience on your way to Kashi, making your trip a memorable one."
    },
    {
        "name": "Mumbai to Kashi Taxi Fare",
        "description": "At Vedant Travels, we offer transparent and competitive taxi fares for your journey from Mumbai to Kashi. We ensure fair pricing with no hidden charges, making your journey cost-effective and stress-free. Contact us for an accurate fare quote based on your trip specifics."
    },
    {
        "name": "Mumbai to Kashi Round Trip",
        "description": "Planning a round trip to Kashi from Mumbai? Vedant Travels provides flexible round-trip taxi services, ensuring you have a comfortable ride both to and from Kashi. Enjoy a smooth and enjoyable journey with our reliable round-trip options."
    },
    {
        "name": "Mumbai to Kashi Cab Rental",
        "description": "If you're looking for a convenient and reliable way to travel to Kashi, rent a cab with Vedant Travels. Our well-maintained vehicles and professional drivers ensure a safe, comfortable, and enjoyable rental experience."
    }
],



"tableData": [
    ["Mumbai to Kashi Cab Service", "Mumbai to Kashi One Way Taxi"],
    ["Mumbai to Kashi Car Hire", "Mumbai to Kashi Taxi Booking"],
    ["Kashi Darshan Taxi", "Mumbai to Kashi Innova"],
    ["Mumbai to Kashi Trip", "Mumbai to Kashi Taxi Fare"],
    ["Mumbai to Kashi Round Trip", "Mumbai to Kashi Cab Rental"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the importance of punctuality, especially when traveling for a sacred journey. Whether you're visiting Kashi for spiritual reasons or leisure, our drivers ensure timely pickups and drop-offs, making your journey seamless and stress-free."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Enjoy a comfortable and relaxing ride in our spacious, well-maintained vehicles. With ample legroom, air conditioning, and comfortable seating, your journey from Mumbai to Kashi will be smooth, allowing you to focus on your destination."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our experienced drivers are well-trained in handling long-distance journeys, especially from Mumbai to Kashi. They are skilled at navigating various routes and ensure a safe, efficient, and comfortable ride. They are also courteous and knowledgeable about the area."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive pricing for your Mumbai to Kashi journey. We believe in complete transparency, with no hidden charges. Our upfront pricing ensures you get great value for your money."
    },
    {
      "WhyChooseheading": "Safe and Secure Travel",
      "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a worry-free and secure journey."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you’re planning an early morning trip or a late-night arrival, Vedant Travels is available around the clock to serve you. Our customer support team is always ready to assist you with any booking or travel-related needs."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Kashi cab is easy and convenient. You can book online through our website or mobile app, or contact our customer service team for assistance. We ensure a quick and simple booking process to meet your needs."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "Whether you're traveling for a pilgrimage, spiritual exploration, or leisure, we offer personalized travel packages to suit your specific requirements. Let us know your preferences, and we’ll tailor the journey to ensure your comfort and convenience."
    }
  ]
    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Kashi cab with Vedant Travels?',
            answer: 'You can easily book your cab online via our website or mobile app. Alternatively, you can reach out to our customer service team for assistance with your booking.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel from Mumbai to Kashi?',
            answer: 'Yes, our drivers are experienced in handling long-distance trips, ensuring that you have a safe, smooth, and timely journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the Mumbai to Kashi journey?',
            answer: 'We offer a range of well-maintained vehicles, including sedans, SUVs, and luxury cars. All our vehicles are designed for comfort and equipped for long-distance travel.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Kashi cab rental?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payment via our app, making payment convenient for you.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab for Mumbai to Kashi?',
            answer: 'Yes, you can book a round-trip cab. Simply provide your return details during the booking process, and we will ensure your travel is comfortable and timely.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours during the Mumbai to Kashi trip?',
            answer: 'Any additional charges for waiting or detours will be communicated to you upfront. We are transparent in our pricing and ensure there are no hidden costs.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Kashi?',
            answer: 'Yes, we offer sightseeing tours in Kashi as part of your trip. Visit iconic places like Kashi Vishwanath Temple, Dashashwamedh Ghat, and other spiritual landmarks with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for the Mumbai to Kashi cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have extra or special luggage, please let us know at the time of booking so we can make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Kashi?',
            answer: 'Yes, we offer corporate travel services for business trips or group travel. Whether you are traveling for business meetings or conferences, we can provide a comfortable, professional service.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Kashi travel?',
            answer: 'Vedant Travels provides reliable, comfortable, and affordable cab services. With experienced drivers, well-maintained vehicles, and transparent pricing, we ensure your trip from Mumbai to Kashi is smooth, safe, and hassle-free.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Anand Sharma",
            title: "Pilgrimage Traveler",
            quote: "I traveled from Mumbai to Kashi for a religious pilgrimage with Vedant Travels, and the experience was amazing. The driver was professional, the vehicle was comfortable, and I reached my destination without any hassle. I highly recommend their service!",
            rating: 5,
        },
        {
            name: "Mrs. Priya Kapoor",
            title: "Family Traveler",
            quote: "I booked a cab for my family trip from Mumbai to Kashi, and it was a pleasant journey. The vehicle was clean and spacious, and the driver was courteous and knowledgeable. I’ll definitely use Vedant Travels for my future trips.",
            rating: 5,
        },
    ];
    
    
    
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
      
   

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Kashi Cab Service",
  "image": "https://vedanttravels.in/assets/images/mumbai-to-kashi-cab-service.jpg",
  "description": "Book Mumbai to Kashi cab service with Vedant Travels for a safe and comfortable pilgrimage journey. AC sedans, SUVs, and tempo travellers available for one-way and round trips to the holy city of Kashi (Varanasi).",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9999",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-to-kashi-cab-service"
  }
};


  


    return (
        <div>
           
        
<Helmet>
  <title>Mumbai to Kashi Cab Service | Pilgrimage Travel | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai to Kashi cab service with Vedant Travels for a safe and comfortable pilgrimage journey. AC sedans, SUVs, and tempo travellers available for one-way and round trips to the holy city of Kashi (Varanasi)." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Kashi Cab Service, Kashi Pilgrimage Cab Mumbai, Mumbai to Varanasi Taxi, Vedant Travels Mumbai Kashi, Pilgrimage Cab Booking Mumbai, AC Cab Mumbai Kashi, SUV Cab Mumbai Kashi, Outstation Cab Mumbai Kashi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/91.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitokashicabservice;